import React, { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import { User, Menu, X, ChevronDown, UserCircle, LogOut, Shield, Calendar, CalendarCheck } from 'lucide-react';
import LoginModal from './auth/LoginModal';
import SignupModal from './auth/SignupModal';
import './Header.css';
import authService from '../services/authService';
import { useNavigate } from "react-router-dom";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [signupOpen, setSignupOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const storedUser = authService.getUser();
      if (storedUser) {
        const currentUser = await authService.getCurrentUser();
        if (currentUser) {
          setUser(storedUser);
        } else {
          setUser(null);
        }
      } else {
        setUser(null);
      }
    };

    checkAuth();
    
    // Escutar evento de mudança de auth
    const handleAuthChange = () => {
      checkAuth();
    };
    
    window.addEventListener("authStateChanged", handleAuthChange);
    
    const interval = setInterval(checkAuth, 60000);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener("authStateChanged", handleAuthChange);
    };
  }, []);

  const handleLogout = () => {
    authService.logout();
    setUser(null);
    setMobileMenuOpen(false);
    navigate("/");
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    const names = name.split(' ');
    if (names.length === 1) return name.charAt(0).toUpperCase();
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };

  const getFirstName = (name) => {
    if (!name) return 'Usuário';
    return name.split(' ')[0];
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="header-top">
            <Link to="/" className="logo-link">
              <div className="logo-text">
                <img src="/assets/image7.png" alt="Logo" />
              </div>
            </Link>

            <div className="header-actions">
              {user ? (
                <div className="user-dropdown">
                  <div className="user-info">
                    <div className="user-avatar">
                      {getInitials(user.nome || user.email)}
                    </div>
                    <div className="user-text">
                      <p className="user-greeting">Olá,</p>
                      <p className="user-name">{getFirstName(user.nome || user.email)}</p>
                    </div>
                    <ChevronDown size={18} className="user-dropdown-icon" />
                  </div>
                  <div className="user-menu">
                    <div className="user-menu-header">
                      <p className="user-menu-email">{user.email}</p>
                    </div>
                    
                    {user.isAdmin && (
                      <>
                        <Link 
                          to="/admin/dashboard" 
                          className="user-menu-item"
                        >
                          <Shield size={18} />
                          Painel de Administrador
                        </Link>
                        <Link 
                          to="/admin/eventos" 
                          className="user-menu-item"
                        >
                          <Calendar size={18} />
                          Gestão de Eventos
                        </Link>
                      </>
                    )}
                    
                    <Link 
                      to="/meus-participantes" 
                      className="user-menu-item"
                    >
                      <UserCircle size={18} />
                      Meus Participantes
                    </Link>
                    
                    <Link 
                      to="/meus-agendamentos" 
                      className="user-menu-item"
                    >
                      <CalendarCheck size={18} />
                      Meus Agendamentos
                    </Link>

                    <Link 
                      to="/historico" 
                      className="user-menu-item"
                    >
                      <CalendarCheck size={18} />
                      Histórico de Agendamentos
                    </Link>
                    
                    <button 
                      className="user-menu-item logout"
                      onClick={handleLogout}
                    >
                      <LogOut size={18} />
                      Logout
                    </button>
                  </div>
                </div>
              ) : (
                <button className="login-btn" onClick={() => setLoginOpen(true)}>
                  <User size={18} />
                  <span>Log In</span>
                </button>
              )}
              {/*
              <button className="cart-btn" onClick={() => setCartOpen(true)}>
                <ShoppingCart size={20} />
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </button>
              */}
            </div>

            <button 
              className="mobile-menu-btn"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          <nav className="nav-desktop">
            <Link to="/" className="nav-link">Página inicial</Link>
            {/*<Link to="/oficinas-de-verao-2025" className="nav-link">Oficinas de Verão 2025</Link>*/}
            <Link to="/sobre-nos" className="nav-link">Sobre nós</Link>
            <Link to="/clube-barco" className="nav-link">Clube Barco de Papel</Link>
            <Link to="/festas-aniversario" className="nav-link">Festas Aniversário</Link>
            <Link to="/agendamento" className="nav-link">Agendamento online</Link>
            <Link to="/contacto" className="nav-link">Entre em Contacto</Link>
          </nav>

          <nav className={`nav-mobile ${mobileMenuOpen ? 'active' : ''}`}>
            <Link to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Página inicial
            </Link>
            <Link to="/oficinas-de-verao-2025" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Oficinas de Verão 2025
            </Link>
            <Link to="/sobre-nos" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Sobre nós
            </Link>
            <Link to="/clube-barco" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Clube Barco de Papel
            </Link>
            <Link to="/festas-aniversario" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Festas Aniversário
            </Link>
            <Link to="/agendamento" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Agendamento online
            </Link>
            <Link to="/contacto" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Entre em Contacto
            </Link>
            
            <div className="mobile-actions">
              {user ? (
                <div className="mobile-user-menu">
                  <div style={{ padding: '0.5rem 0', color: '#4A8080', fontWeight: '600' }}>
                    {user.nome || user.email}
                  </div>
                  
                  {user.isAdmin && (
                    <>
                      <Link 
                        to="/admin/dashboard" 
                        className="user-menu-item"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <Shield size={18} />
                        Painel de Administrador
                      </Link>
                      <Link 
                        to="/admin/eventos" 
                        className="user-menu-item"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <Calendar size={18} />
                        Gestão de Eventos
                      </Link>
                    </>
                  )}
                  
                  <Link 
                    to="/meus-participantes" 
                    className="user-menu-item"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <UserCircle size={18} />
                    Meus Participantes
                  </Link>
                  
                  <Link 
                    to="/meus-agendamentos" 
                    className="user-menu-item"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <CalendarCheck size={18} />
                    Meus Agendamentos
                  </Link>
                  
                  <button 
                    className="user-menu-item"
                    onClick={handleLogout}
                  >
                    <LogOut size={18} />
                    Logout
                  </button>
                </div>
              ) : (
                <button className="login-btn" onClick={() => setLoginOpen(true)}>
                  <User size={18} />
                  <span>Log In</span>
                </button>
              )}{/* 
              <button className="cart-btn" onClick={() => setCartOpen(true)}>
                <ShoppingCart size={20} />
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </button>
              */}
            </div>
          </nav>
        </div>
      </header>

      {/*<CartSidebar isOpen={cartOpen} onClose={() => setCartOpen(false)} />*/}
      
      <LoginModal 
        isOpen={loginOpen} 
        onClose={() => setLoginOpen(false)}
        onSwitchToSignup={() => {
          setLoginOpen(false);
          setSignupOpen(true);
        }}
      />
      
      <SignupModal 
        isOpen={signupOpen} 
        onClose={() => setSignupOpen(false)}
        onSwitchToLogin={() => {
          setSignupOpen(false);
          setLoginOpen(true);
        }}
      />
    </>
  );
}